import { ServiceProviderEmrConnectionFull } from "./service-provider-emr-connection";

export interface AddServiceProviderEmrConnectionResponse {
    result: "ok" | "duplicate-name";
    connection: ServiceProviderEmrConnectionFull | null;
}
